<template>
	<div>
		<cTable ref="table" :config="config" :fields="fields" :footer="{show:()=>false}"></cTable>
	</div>
</template>

<script>
	import cTable from "@/base/common/index";
	export default {
		components: {
			cTable
		},
		props:{
			row:{
				type:Object,
				default:()=>({
					weight:0,
					quantity:0,
					volume:0
				})
			},
			read:{
				type:Boolean,
				default:false
			},
			list:{
				type:Array,
				default:()=>[]
			}
		},
		mounted(){
			this.debounceComputedList = this.debounce(this.computedList)
			setTimeout(()=>{
				this.$nextTick(()=>{
					if(this.$refs['table'])this.$refs['table'].list = this.list
					this.debounceComputedList(this.list)
				})
			},500)
		},
		watch: {
			list:{
				handler(newValue, oldValue) {
					this.debounceComputedList(newValue)
				},
				deep:true,
			}
		},
		methods:{
			computedList(list){
				console.log('chufa',list);
				this.row.weight = 0
				this.row.quantity = 0
				this.row.volume = 0
				list.forEach(t=>{
					this.row.weight += t.weight || 0
					this.row.quantity += t.quantity || 0
					this.row.volume = parseFloat((this.row.volume + t.volume).toFixed(2))
				})
			},
			debounce(fn, num = 200) {
			  let timeId = null;
			  return function () {
			    clearTimeout(timeId);
			    timeId = setTimeout(() => {
			      let newTime = new Date().getTime();
			      fn.call(this, ...arguments);
			    }, num);
			  };
			},
			computedVolumn(row){
				row.volume = parseFloat((row.height * row.width * row.length * row.quantity / 1000000).toFixed(2)) || 0
			}
		},
		data() {
			return {
				debounceComputedList:()=>{},
				config:{
					slot:'div',
					height:300,
					resize:false
				},
				fields:[
					{
						name: () => this.$t('productName'),
						placeholder:()=>this.$t("productName"),
						key: "name",
						minWidth: 130,
						component:!this.read&&'Input'
					},
					{
					  name: this.$t("case_number"),
						component:!this.read&& "InputNumber",
						bind:{
							style:'width:100%'
						},
						default:0,
						placeholder:()=>this.$t("enter")+this.$t("case_number"),
						minWidth: 130,
					  key: "quantity",
						methods:{
							'on-change':({row})=>{
								this.computedVolumn(row)
							}
						}
					},
					{
					  name: this.$t("Weight"),
					  key: "weight",
						component: !this.read&& "InputNumber",
						bind:{
							style:'width:100%'
						},
						default:0,
					  placeholder:()=>this.$t("enter")+this.$t("Weight"),
						minWidth: 130,
						methods:{
							'on-change':({row})=>{
								this.computedVolumn(row)
							}
						}
					},
					{
					  name: this.$t("length"),
					  key: "length",
						component: !this.read&& "InputNumber",
						bind:{
							style:'width:100%'
						},
						default:0,
					  placeholder:()=>this.$t("enter")+this.$t("length"),
						minWidth: 130,
						methods:{
							'on-change':({row})=>{
								this.computedVolumn(row)
							}
						}
					},
					{
					  name: this.$t("width"),
					  key: "width",
						component: !this.read&& "InputNumber",
						bind:{
							style:'width:100%'
						},
						default:0,
					  placeholder:()=>this.$t("enter")+this.$t("width"),
						minWidth: 130,
						methods:{
							'on-change':({row})=>{
								this.computedVolumn(row)
							}
						}
					},
					{
					  name: this.$t("height"),
					  key: "height",
						component: !this.read&& "InputNumber",
						bind:{
							style:'width:100%'
						},
						default:0,
					  placeholder:()=>this.$t("enter")+this.$t("height"),
						minWidth: 130,
						methods:{
							'on-change':({row})=>{
								this.computedVolumn(row)
							}
						}
					},
					{
					  name: this.$t("skuVolume"),
					  key: "volume",
						component: !this.read&& "InputNumber",
						bind:{
							style:'width:100%'
						},
						default:0,
						disabled:true,
					  placeholder:()=>this.$t("enter")+this.$t("skuVolume"),
						minWidth: 130,
					},
					{
					  name: this.$t("Remarks"),
					  key: "remarks",
						component: !this.read&& "Input",
						minWidth: 130,
					  placeholder:()=>this.$t("enter")+this.$t("Remarks"),
					},
					{
					  type: "btns",
					  width: 160,
					  name: () => this.$t("operation"),
					  fixed: "right",
						show:()=>{
							return !this.read
						},
					  // width({ field }) {
					  //   return field.list.length * 40 + 40;
					  // },
					  list: [
					    {
					      name: () => this.$t("add"),
					      type: "add",
					      fnName: "add",
					      bind: {
					        type: "warning",
					      },
					      icon: "md-add",
								show:()=>{
									return !this.read
								},
					    },
					    {
					      name: () => this.$t("delete"),
					      type: "delete",
					      fnName: "delete",
					      icon: "md-trash",
								show:()=>{
									return !this.read
								},
					    },
					  ],
					  methods: {
					    add({ row,rowIndex }) {
								this.list.splice(rowIndex,0,{
								name:'',
								length:0,
								height:0,
								width:0,
								quantity:0,
								volume:0,
								weight:0,
							})
					    },
					    delete({ row,rowIndex }) {
								this.list.splice(rowIndex,1)
								if(!this.list.length)this.list.push({
									name:'',
									length:0,
									height:0,
									width:0,
									quantity:0,
									volume:0,
									weight:0,
								})
					    },
					  },
					},
				]
			}
		},
	}
</script>

<style scoped>

</style>